import { useUser } from '@application/authentication/use_user';
import { withTranslation } from '@application/i18n/with_translation';
import { BadgeNumber, Bleed, Flex, TabNavigation } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useCountedIssues } from '@feature/issues/use_counted_issues';
import * as ScrollArea from '@radix-ui/react-scroll-area';
import { PropsWithChildren } from 'react';
import { SignInEmptyState } from './_sign_in_empty_state.component';
import { ActivatedTab } from './activated_tab.component';

export function ListRoot(props: PropsWithChildren) {
	const ongoingIssues = useCountedIssues(['ongoing']);
	const completedIssues = useCountedIssues(['completed']);
	const user = useUser();

	return (
		<Flex
			gap={tokens.size.x3}
			style={{
				width: '100%',
				margin: `${tokens.size.x4} auto`,
				padding: `0 ${tokens.size.x2}`,
			}}
		>
			{props.children}

			{user == null ? <SignInEmptyState /> : null}

			<Bleed bleedAmount='8px'>
				<ScrollArea.Root
					style={
						/* A bit of a hack to get the tab bar to function */
						user == null
							? {
									display: 'none',
								}
							: undefined
					}
				>
					<ScrollArea.Viewport
						style={{
							width: '100%',
							height: '100%',
							padding: `0 ${tokens.size.x1} ${tokens.size.x4}`,
						}}
					>
						<TabNavigation.Content
							disabled={user == null}
							label={withTranslation('PW.Component.Visits.TabBar.Ongoing')}
							hiddenLabel={
								ongoingIssues === 0
									? withTranslation('PW.Component.Visits.TabBar.Ongoing.A11y')
									: withTranslation(
											ongoingIssues > 1
												? 'PW.Component.Visits.TabBar.Ongoing.A11y.WithIssues'
												: 'PW.Component.Visits.TabBar.Ongoing.A11y.WithIssue',
											{
												notifications: ongoingIssues.toString(),
											},
										)
							}
							value='tab1'
							trailingSlot={ongoingIssues !== 0 ? <BadgeNumber value={ongoingIssues} decorative /> : null}
						>
							<ActivatedTab tab='tab1' />
						</TabNavigation.Content>
						<TabNavigation.Content
							disabled={user == null}
							label={withTranslation('PW.Component.Visits.TabBar.Completed')}
							hiddenLabel={
								completedIssues === 0
									? withTranslation('PW.Component.Visits.TabBar.Completed.A11y')
									: withTranslation(
											completedIssues > 1
												? 'PW.Component.Visits.TabBar.Completed.A11y.WithIssues'
												: 'PW.Component.Visits.TabBar.Completed.A11y.WithIssue',
											{
												notifications: completedIssues.toString(),
											},
										)
							}
							value='tab2'
							trailingSlot={completedIssues !== 0 ? <BadgeNumber value={completedIssues} decorative /> : null}
						>
							<ActivatedTab tab='tab2' />
						</TabNavigation.Content>
					</ScrollArea.Viewport>
				</ScrollArea.Root>
			</Bleed>
		</Flex>
	);
}
